import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  isLoading?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  isLoading,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center px-8 py-3 text-base font-medium transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-vitalityTeal disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-deepCanopy text-vitalityTeal border border-vitalityTeal/30 hover:shadow-glow hover:border-vitalityTeal hover:text-bioLuminescentTeal',
    outline: 'bg-transparent text-myceliumWhite border border-myceliumWhite/30 hover:border-vitalityTeal hover:text-vitalityTeal',
    ghost: 'bg-transparent text-myceliumWhite hover:text-vitalityTeal hover:bg-white/5'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} disabled={isLoading || props.disabled} {...props} data-id="element-280">
      {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-281" />}
      {children}
      {variant === 'primary' && <div className="absolute inset-0 rounded-full ring-1 ring-vitalityTeal/20 pointer-events-none" data-id="element-282" />}
    </motion.button>;
}